/**
 * This RegExp gets all the characters that cannot be used directly to a regexp expression.
 * Gets the characters +, \, [, ] and ?.
 * The first and last '/' starts and finishes the regex expression.
 * The '[]' that encapsulates everything matches any character that is inside it.
 * '+' matches '+'
 * '\\' matches '\'
 * '[' matches '['
 * '\]' matches ']'
 * '?' matches '?'
*/
const invalidRegexCharacters = /[+\\[\]?]/;

/**
 * Regular expression to check if a value is a number.
 */
export const isNumber = /\d/;
export const personName = /^[a-zA-Z\s'-]+$/;

export default invalidRegexCharacters;
